<template>
    <div class="page-wrapper page" :class="showRoute">
        <div class="space-helper"></div>

        <div v-if="showRoute == 'locations'" class="page-grid-fix" id="London">
            <article class="grid-container columns-three-two-rows location regular-gap" >
                  
                <section class="section1" style="height: auto;">
                    <div class="bg-image" style="background-image: url(/uploads/V2NinetyMountStreet-1.JPEG);" v-show="!showLondonDetails"></div>
                    <div style="margin-top: 0;" v-show="showLondonDetails">
                        <div>
                            <pre style="margin-top: 0;">Request an appointment in {{ londonboutique.name }}</pre>
                            <EnquiryFormBranchAppointment formOrigin="Location - London Boutique Enquiry" branch="Genève" style="padding: 0; margin-top: 46px;"></EnquiryFormBranchAppointment>
                        </div>
                    </div>
                </section>

                <section class="section2 regular-gap" style="align-items: start;">
                    <div>
                        <h2 class="title" style="margin-bottom: 0;">{{ londonboutique.name }}</h2>
                        
                        <p class="description">{{ londonboutique.Description }}</p>
                        <div class="toggle-arrow">
                            <span @click="toggleLondonDetails" >
                                <a class="show-more" v-if="showLondonDetails">Hide contact details</a>
                                <a class="show-more" v-else>Boutique contact details</a>
                            </span>
                        </div>
                        <div class="contact-boutique-details" v-show="showLondonDetails">
                            <div v-if="londonboutique.Email" class="contact-email">
                                <span>Email</span>
                                <a :href="'mailto:' + londonboutique.Email"> {{ londonboutique.Email }}</a>
                            </div>
                            <div v-if=" londonboutique.PhoneNumber" class="contact-tephone">
                                <span>Telephone</span>
                                <a :href="'tel:' + londonboutique.PhoneNumber">{{ londonboutique.PhoneNumber }}</a></div>
                            <div v-if="londonboutique.WhatsAppNumber" class="contact-whatsapp">
                                <span>WhatsApp</span>
                                <a :href="'https://api.whatsapp.com/send?phone='+ londonboutique.WhatsAppNumber">{{ londonboutique.WhatsAppNumber }}</a></div>
                            <div v-if="londonboutique.AddressFirst" class="contact-address">
                                <span>Address</span><br />
                                {{ londonboutique.AddressFirst }}<br />
                                {{ londonboutique.AddressSecond }}<br /><br />
                                <div v-if="londonboutique.OpeningHours" class="opening-hours">
                                    <span>Open</span>
                                    <div v-html="formattedLondonOpeningHours"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section class="section3">
                </section>
            </article>
        </div>
        

        <div v-if="showRoute == 'locations'" class="page-grid-fix" id="Geneva">
            <article class="grid-container columns-three-two-rows mirrored location regular-gap" >
               
                <section class="section1" style="height: auto;">
                    <div class="bg-image" style="background-image: url(/images/9tgeneva-scetch.jpeg);" v-if="!showGenevaDetails"></div>
                    <div style="margin-top: 0;" v-show="showGenevaDetails">
                        <div>
                            <pre style="margin-top: 0;">Request an appointment in {{ genevaboutique.name }}</pre>
                            <EnquiryFormBranchAppointment formOrigin="Location - Genève Boutique Enquiry" branch="Genève" style="padding: 0; margin-top: 46px;"></EnquiryFormBranchAppointment>
                        </div>
                    </div>
                </section>

                <section class="section2 regular-gap" style="align-items: start;">
                    <div>
                        <h2 class="title" style="margin-bottom: 0;">{{ genevaboutique.name }}</h2>
                        
                        <p class="description">{{ genevaboutique.Description }}</p>
                        <div class="toggle-arrow">
                            <span @click="toggleGenevaDetails" >
                                <a class="show-more" v-if="showGenevaDetails">Hide contact details</a>
                                <a class="show-more" v-else>Boutique contact details</a>
                            </span>
                        </div>
                        <div class="contact-boutique-details" v-if="showGenevaDetails">
                            <div v-if="genevaboutique.Email" class="contact-email">
                                <span>Email</span>
                                <a :href="'mailto:' + genevaboutique.Email">{{ genevaboutique.Email }}</a>
                            </div>
                            <div  v-if="genevaboutique.PhoneNumber" class="contact-tephone">
                                <span>Telephone</span>
                                {{ genevaboutique.PhoneNumber }}</div>
                            <div  v-if="genevaboutique.WhatsAppNumber" class="contact-whatsapp">
                                <span>WhatsApp</span>
                                <a :href="'https://api.whatsapp.com/send?phone='+ genevaboutique.WhatsAppNumber">{{ genevaboutique.WhatsAppNumber }}</a></div>
                            <div  v-if="genevaboutique.AddressFirst" class="contact-address">
                                <span>Address</span><br />
                                {{ genevaboutique.AddressFirst }}<br />
                                {{ genevaboutique.AddressSecond }}<br /><br />
                                <div v-if="genevaboutique.OpeningHours" class="opening-hours">
                                <span>Open</span>
                                <div v-html="formattedGenevaOpeningHours"></div>
                            </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section class="section3">
                </section>

            </article>
        </div>


        <div class="page-grid-wrapper" v-if="page[15] == 'standardPage' && showRoute !== 'locations'" :class="page[15]">
            <div class="page-grid-fix">
                <article class="grid-container columns-two tick" v-if="page[9] == true">
                    
                    <section class="section1">
                        <h1>{{ page[2] }}</h1>
                    </section>
                    <section class="section2">
                        <p class="vhtml" v-html="page[3]"></p>
                    </section>

                    <section class="section3">
                        <div class="enquiry" v-if="page[13] == true">
                            <h3>Contact</h3>
                            <EnquiryForm formOrigin="Contact Page"></EnquiryForm> <!-- contact form -->
                            <span class="buttons-inline">
                                <button type="submit">
                                    <router-link to="/the-collection">All Brands</router-link>
                                </button>
                                <button type="submit">
                                    <router-link to="/new-arrivals">New arrivals</router-link>
                                </button>
                            </span>
                        </div>
                        <div class="enquiry"> <!-- Enquiry form -->
                            <h3>Contact us</h3>
                            <SellWatchForm></SellWatchForm> 
                            <span class="buttons-inline">
                                <button type="submit">
                                    <router-link to="/the-collection">All Brands</router-link>
                                </button>
                                <button type="submit">
                                    <router-link to="/new-arrivals">New arrivals</router-link>
                                </button>
                            </span>
                        </div>
                    </section>

                </article>
            </div>
        </div>

<!-- full width top blurb --> 
    
        <div v-else v-for="(value, key, index) in blurbs" :key="index" >
            <div  class="page-grid-fix background-img top-blurb" v-if="key == 0"  v-bind:style="{  backgroundImage:  'linear-gradient(rgba(0, 0, 0, 0.527),rgba(0, 0, 0, 0.5)), ' + 'url(' +  value.blurb_image + ')'}">   
                <!-- <div class="overlay-mask"></div>  --> 
                <article class="grid-container columns-two transparent">

                    <section class="section1 transparent">
                        <div>
                            <h1 v-if="key == 0">{{ value.blurb_title }}</h1>
                            <div v-html=value.blurb_description></div>
                        </div>
                    </section>

                    <section class="section2 transparent">
                        <div v-if="value.blurb_link_title">
                            <button type="submit">
                                <router-link :to=value.blurb_link>{{ value.blurb_link_title }}</router-link>
                            </button>
                        </div>
                    </section>

                </article>
            </div>
        </div>

        <div v-for="(value, key, index) in blurbs" :key="index">
            <div v-if="value.blurb_image && value.blurb_title !== 'Delivery' && value.blurb_title !== 'Buy back'" class="page-grid-wrapper">    
                <div class="page-grid-fix">
                            <article  v-if="key !== 0" class="grid-container columns-two" :class="{showRoute, standardBlurb:key>0, evenBlurb:key % 2 == 0, oddBlurb:key % 2 !== 0 }">
                            <section v-if="value.blurb_image" class="section1">
                                <div style="height: 650px;" class="bg-image" v-bind:style="{ 'backgroundImage': 'url(' + value.blurb_image + ')'}"></div>
                            </section>

                            <section v-if="value.blurb_image" class="section2 padding">
                                    <h4 style="align-self: end;">{{ value.blurb_title }}</h4>
                                    <div style="max-width: 350px; align-self: center;" v-html=value.blurb_description></div>
                                    <button style="align-self: start;" v-if="value.blurb_link_title" class="submit">
                                        <router-link v-bind:to="value.blurb_link">
                                        {{ value.blurb_link_title }}
                                        </router-link>
                                    </button>
                            </section>

                        </article>
                </div>
            </div>
            <div v-if="value.blurb_image && value.blurb_title !== 'Delivery' && value.blurb_title == 'Buy back'" class="page-grid-wrapper">    
                <div class="page-grid-fix background-img"  v-bind:style="{  backgroundImage:  'linear-gradient(rgba(0, 0, 0, 0.527),rgba(0, 0, 0, 0.5)), ' + 'url(' + value.blurb_image + ')'}">
                        <article  v-if="key !== 0" class="grid-container columns-one transparent regular-gap" :class="{showRoute, standardBlurb:key>0}">
                            <section v-if="value.blurb_image" class="section1 transparent">
                                    <h4>{{ value.blurb_title }}</h4>
                                    <div v-html=value.blurb_description></div>
                                    <button v-if="value.blurb_link_title" class="submit">
                                        <router-link v-bind:to="value.blurb_link">
                                        {{ value.blurb_link_title }}
                                        </router-link>
                                    </button>
                                    <div class="space-helper"></div>
                            </section>

                        </article>
                </div>
            </div>

            <div v-if="value.blurb_image && value.blurb_title == 'Delivery' && value.blurb_title !== 'Buy back'" class="page-grid-wrapper">    
                <div class="page-grid-fix  negative-colors">

    <!-- 4th section // e.g. blurbs service page -->
                    <article  v-if="key !== 0" class="grid-container columns-two regular-gap" :class="{showRoute, standardBlurb:key>0, evenBlurb:key % 2 == 0, oddBlurb:key % 2 !== 0 }">
                        <section v-if="value.blurb_image" class="section1">
                            <div style="height: 650px;" class="bg-image" v-bind:style="{ 'backgroundImage': 'url(' + value.blurb_image + ')'}"></div>
                        </section>

                        <section v-if="value.blurb_image" class="section2 padding">
                            <!-- <div> -->
                                <h4 style="align-self: end;">{{ value.blurb_title }}</h4>
                                <div style="max-width: 350px; align-self: center;" v-html=value.blurb_description></div>
                                <button style="align-self: start;" v-if="value.blurb_link_title" class="submit">
                                    <router-link v-bind:to="value.blurb_link">
                                    {{ value.blurb_link_title }}
                                    </router-link>
                                </button>
                        </section>
                    </article>
                </div>
            </div>

    <!-- full width video -->  
            <div class="page-grid-fix background-img background-img-video" v-if="value.blurb_video"  v-bind:style="{  backgroundImage:  'linear-gradient(rgba(0, 0, 0, 0.527),rgba(0, 0, 0, 0.5)), ' + 'url(' +  value.blurb_image + ')'}">   
                <article class="grid-container columns-one transparent">

                    <section class="section1 transparent">
                        <video v-if="value.blurb_video" playsinline autoplay muted loop class="bg-video">
                                <source v-bind:src="value.blurb_video" type="video/mp4">
                            </video>
                    </section>

                </article>                
            </div>
        </div>
    </div>
</template>

<script>
import ContactForm from '../components/ContactForm.vue';
import EnquiryForm from '../components/EnquiryForm.vue';
import EnquiryFormBranchAppointment from '../components/EnquiryFormBranchAppointment.vue';
import SellWatchForm from '../components/SellWatchForm.vue'

export default {
    name: 'Page',
    components: {
        ContactForm,
        EnquiryForm,
        EnquiryFormBranchAppointment,
        SellWatchForm,
    },
    props: {
        londonboutique: {
        type: Object,
        required: true, // Ensure the parent always provides this prop
        },
        genevaboutique: {
        type: Object,
        required: true,
        },
    },
    data() {
        return {
            showGenevaDetails: false,
            showLondonDetails: false,
            banner: '',
            page: [],
            blurbs: [],
            showRoute: {
                showRoute : this.$route.name
           },
        };
    },    
    watch: {
        '$route.name': function () {
          this.showRoute = this.$route.name;
          this.getPage(); // Re-fetch data when route changes
        },
    },
    created() {
        this.showRoute = this.$route.name
    },
    mounted() {
        this.getPage();
        this.$emit("route-data-ready"); // tells App.vue to hide loader
        const location = this.$route.query.location;
        // console.log('Location from query:', location); // Debugging line

        // Delay scrolling to ensure all content is loaded
        if (location) {
            setTimeout(() => {
                this.scrollToLocation(location);
            }, 1000); // Adjust the delay time (in milliseconds) as needed
        }
    },
    computed: {     
        bannerVideo() {
            var file = this.page[7];
            if ( file.includes('mp4') == 1) {
                return 'video'
            } 
        },
        bannerImage() {
            var file = this.page[7];
            if ( file.includes('jpg') == 1) {
                return 'image'
            } 
        },
        formattedLondonOpeningHours() {
            return this.londonboutique.OpeningHours.replace(/, /g, "<br/>");
        },
        formattedGenevaOpeningHours() {
            return this.genevaboutique.OpeningHours.replace(/, /g, "<br/>");
        }
    },
    methods: {
        toggleGenevaDetails() {
            this.showGenevaDetails = !this.showGenevaDetails;
        }, 
        toggleLondonDetails() {
            this.showLondonDetails = !this.showLondonDetails;
        }, 
        getPage(address) {
            var pageSlug = this.showRoute;
            if ( pageSlug !== 'locations') {
                this.$axios.get(address ? address : "/api/" + pageSlug).then(response => {
                    this.page = response.data;
                    this.blurbs = response.data[11];
                    // this.$emit("route-data-ready"); // tells App.vue to hide loader
                });
            }
        },
        scrollToLocation(location) {
            const element = document.getElementById(location);
            if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
            } else {
                console.error(`Element with ID ${location} not found.`); // Error logging
            }
        },
    },
};
</script>
